import { useEffect, useState } from "react";

import useEnvironmentVariableData from "@usas/ui-web/state/environmentVariable/UseEnvironmentVariableData";
import useOrgRoleStaffRoleHierarchyData from "@usas/ui-web/state/orgRoleStaffRoleHierarchy/UseOrgRoleStaffRoleHierarchyData";

const INITIAL_GRID_STATE = {
  orgRole: [],
  orgRoleFilterIds: [],
  gridData: []
};

const useClubStaffGrid = (data) => {
  const { CLUB_STAFF_ROLE_GROUP_ID } = useEnvironmentVariableData();
  const { orgRoleStaffRoleHierarchyState } = useOrgRoleStaffRoleHierarchyData();
  const [gridState, setGridState] = useState(INITIAL_GRID_STATE);

  const onOrgRoleFilterChanged = (orgRole) => {
    const newOrgRoleFilterIds = getOrgRoleFilterIds(orgRole);
    const newGridData = data.filter((staff) => {
      for (const staffOrgRole of staff.personOrgRole) {
        if (newOrgRoleFilterIds.length === 0 || newOrgRoleFilterIds.includes(staffOrgRole.orgRoleId)) {
          return true;
        }
      }
    });

    setGridState({
      ...gridState,
      orgRole,
      newOrgRoleFilterIds,
      gridData: newGridData
    });
  }

  useEffect(() => {
    if (Array.isArray(data)) {
      const newGridData = data.filter((staff) => {
        for (const staffOrgRole of staff.personOrgRole) {
          if (gridState.orgRoleFilterIds.length === 0 || gridState.orgRoleFilterIds.includes(staffOrgRole.orgRoleId)) {
            return true;
          }
        }
      });

      setGridState({
        ...gridState,
        gridData: newGridData
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps   
  }, [data]);

  function getOrgRoleFilterIds(orgRoles) {
    function getOrgRoleIdFromChildren(node, orgRoleId, parentIsSelected = false) {
      let orgRoleIds = [];

      if (node.id === orgRoleId || parentIsSelected) {
        orgRoleIds.push(node.id);

        if (Array.isArray(node.children)) {
          node.children.forEach((child) => {
            orgRoleIds = orgRoleIds.concat(getOrgRoleIdFromChildren(child, orgRoleId, true));
          });
        }
      } else if (Array.isArray(node.children) && node.children.length > 0) {
        if (Array.isArray(node.children)) {
          node.children.forEach((child) => {
            orgRoleIds = orgRoleIds.concat(getOrgRoleIdFromChildren(child, orgRoleId, parentIsSelected));
          });
        }
      }

      return orgRoleIds;
    }

    let orgRoleIds = [];

    if (Array.isArray(orgRoles)) {
      for (const orgRole of orgRoles) {
        orgRoleStaffRoleHierarchyState.arrayData.forEach((node) => {
          orgRoleIds = orgRoleIds.concat(getOrgRoleIdFromChildren(node, orgRole.id, false));
        });
      }
    }

    orgRoleIds = [...new Set(orgRoleIds)];
    return orgRoleIds;
  }

  return {
    roleGroupId: CLUB_STAFF_ROLE_GROUP_ID,
    gridState,
    onOrgRoleFilterChanged
  };
};

export default useClubStaffGrid;